import { combineReducers } from 'redux';

import { pricingReducer as pricing } from 'js/src/data/pricing/pricing-slice';

export const getPricingRootReducer = () => {
    return combineReducers({
        pricing,
    });
};
